// English source strings of the account security tab (decision D30): self-service regeneration of the authenticator
// (password + current code → new key → code of the new app). Merged into `en`; pt-BR lives in pt-BR-security.ts
// (complete, checked by the type).
export const enSecurity = {
  "settings.tab.security": "Security",
  "security.mfa.title": "Two-factor authentication",
  "security.mfa.intro": "Your account is protected by an authenticator app. To move it to a new phone or app, regenerate it here with your password and a current code.",
  "security.mfa.notEnabled": "Two-factor authentication is not enabled for your account.",
  "security.mfa.lostHint": "Lost your authenticator? Ask the platform operator to reset it; then sign in with your e-mail and password and set up a new app.",
  "security.mfa.regenerate": "Regenerate two-factor authentication",
  "security.mfa.step1Title": "Step 1 of 3 — Confirm it's you",
  "security.mfa.currentCode": "Current code",
  "security.mfa.currentCodeHint": "The 6-digit code your current authenticator app shows now.",
  "security.mfa.continue": "Continue",
  "security.mfa.step2Title": "Step 2 of 3 — Add the new key",
  "security.mfa.step2Body": "Add a new account in your authenticator app with this setup key. Your current app keeps working until you confirm.",
  "security.mfa.expiresAt": "Confirm this key by {time}; after that, start again.",
  "security.mfa.added": "I added it",
  "security.mfa.step3Title": "Step 3 of 3 — Confirm the new app",
  "security.mfa.newCode": "Code from the new app",
  "security.mfa.newCodeHint": "If a code is refused right after step 1, wait for the next code and try again.",
  "security.mfa.confirm": "Confirm new authenticator",
  "security.mfa.invalidCredentials": "Invalid password or verification code.",
  "security.mfa.invalidCode": "Invalid verification code.",
  "security.mfa.rateLimited": "Too many attempts. Wait a few minutes and try again.",
  "security.mfa.verifySession": "Verify this session with your current code first: sign out and sign in again.",
  "security.mfa.expired": "The new key expired before it was confirmed. Start again.",
  "security.mfa.successTitle": "Two-factor authentication regenerated",
  "security.mfa.successBody": "Use only the new app from now on: the old one no longer works. Every other session of your account was signed out; sign in again there with a code of the new app.",
} as const;
